import React from "react";
import MenuIcon from "@material-ui/icons/Menu";
import "./superNav.css";

/**
 * SuperTopbar - thin top bar above the routed page.
 *
 * Carries the current page title and the mobile menu toggle, nothing
 * else. The bar it replaces (components/Navbars/AdminNavbar.js) reserved
 * space for a search box and a notifications/profile menu that were both
 * commented out, plus a sidebar-minimize control; log out now lives in
 * one place, the sidebar, rather than being offered twice.
 */
const SuperTopbar = ({ title, onOpenMobile }) => {
  return (
    <header className="superTopbar">
      <button
        type="button"
        className="superTopbarMenuButton"
        onClick={onOpenMobile}
        aria-label="Open menu"
      >
        <MenuIcon fontSize="small" />
      </button>
      <h1 className="superTopbarTitle">{title}</h1>
    </header>
  );
};

export default SuperTopbar;
